import { useContext } from "react";

import { WakeLockContext } from "./WakeLockContext";
export function useWakeLockContext() {
  const context = useContext(WakeLockContext);
  if (!context) {
    throw new Error("useWakeLockContext must be used within WakeLockProvider");
  }
  return context;
}
